import { fetchInstance } from '@/utils/fetchInstance';

export interface EventState {
  active: boolean;
  timerReductionPercent: number;
}

export const getEvents = async (): Promise<EventState> => {
  return fetchInstance.get<EventState>('events');
};